import { Injectable } from '@angular/core'
import { ParseService } from 'src/app/parse.service'

@Injectable({
    providedIn: 'root',
})
export class ChoozlePixelService {
    constructor(private parseService: ParseService) {}
    trackSignUp() {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            const pixel = document.createElement('img')

            pixel.src = 'https://insight.adsrvr.org/track/pxl/?adv=35uva1t&ct=0:qm2uv2a&fmt=3'
            pixel.height = 1
            pixel.width = 1
            pixel.style.borderStyle = 'none'
            pixel.alt = ''

            document.body.appendChild(pixel)
        } catch (err) {
            this.parseService.reportUIError(err, 'ChoozlePixelService.trackSignUp', '')
        }
    }

    trackPurchase(saleAmount: number, currency: 'USD', orderType: 'MO' | 'ML') {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (saleAmount <= 0) {
                return
            }

            const pixel = document.createElement('img')

            const userID = this.parseService.user.value
            const orderID = `${orderType}-${userID?.id ?? ''}-${Date.now()}`

            pixel.src = `https://insight.adsrvr.org/track/pxl/?adv=35uva1t&ct=0:idxvssu&fmt=3&v=${saleAmount}&vf=${currency}&orderid=${orderID}`
            pixel.height = 1
            pixel.width = 1
            pixel.style.borderStyle = 'none'
            pixel.alt = ''

            document.body.appendChild(pixel)
        } catch (err) {
            this.parseService.reportUIError(err, 'ChoozlePixelService.trackPurchase', '')
        }
    }
}
